/**
 * @generated SignedSource<<23bd4ea7e98930b7c72ebf4bb3dd193c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NineBoxFilter = {
  isOnMyTeam?: boolean | null | undefined;
  search?: string | null | undefined;
};
export type NineBoxSelectFieldQuery$variables = {
  after?: string | null | undefined;
  filters?: NineBoxFilter | null | undefined;
  first?: number | null | undefined;
};
export type NineBoxSelectFieldQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NineBoxSelectField_query">;
};
export type NineBoxSelectFieldQuery = {
  response: NineBoxSelectFieldQuery$data;
  variables: NineBoxSelectFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NineBoxSelectFieldQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "NineBoxSelectField_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NineBoxSelectFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NineBoxConnection",
        "kind": "LinkedField",
        "name": "nineBoxes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfoExtended",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NineBoxEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NineBox",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "filters"
        ],
        "handle": "connection",
        "key": "NineBoxSelectField_nineBoxes",
        "kind": "LinkedHandle",
        "name": "nineBoxes"
      }
    ]
  },
  "params": {
    "cacheID": "e91d10d7e40cd59b156cf131f9b0c3b8",
    "id": null,
    "metadata": {},
    "name": "NineBoxSelectFieldQuery",
    "operationKind": "query",
    "text": "query NineBoxSelectFieldQuery(\n  $first: Int\n  $after: String\n  $filters: NineBoxFilter\n) {\n  ...NineBoxSelectField_query_1XoDko\n}\n\nfragment NineBoxSelectField_query_1XoDko on Query {\n  nineBoxes(first: $first, after: $after, filters: $filters) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6421f439f910bf0eaa63e98370931a0f";

export default node;
